import { styled } from 'styles/stitches.config'
import { rem } from 'polished'


export const About = styled('div', {
  marginBottom: 48,

  '@md': {
    display: 'flex',
    justifyContent: 'space-between',
  }
})

export const Item = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginRight: 0,
  marginBottom: 10,

  '@md': {
    marginRight: 22,
    marginBottom: 0,
  },

  '&:last-of-type': {
    marginLeft: 'auto',
    marginRight: 0,
  }
})

export const Text = styled('p', {
  marginLeft: 8,

  color: '$grey600',
  fontFamily: '$manrope',
  fontSize: rem(12),
})